// removed by extract-text-webpack-plugin
module.exports = {"slick-slider":"slick-slider","slick-list":"slick-list","dragging":"dragging","slick-track":"slick-track","slick-loading":"slick-loading","slick-slide":"slick-slide","slick-initialized":"slick-initialized","slick-vertical":"slick-vertical","slick-arrow":"slick-arrow","slick-hidden":"slick-hidden","slick-prev":"slick-prev","slick-next":"slick-next","slick-disabled":"slick-disabled","slick-dotted":"slick-dotted","slick-dots":"slick-dots","slick-active":"slick-active"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/slider/slick.css
// module id = 647
// module chunks = 0 1